export const getImageFileTypeAssetInfoLabel = (
	filewidth: number,
	fileheight: number,
) => (filewidth || fileheight ? `${filewidth} x ${fileheight}` : undefined);

export default getImageFileTypeAssetInfoLabel;
